<template>
  <div>
  <b-row>
    <b-col cols="12">
      <label>{{$t("views.agreements.form.autoInvoicing")}}:</label>
      <b-form-group>
        <b-form-radio-group buttons button-variant="outline-primary" id="advance_payment" v-model="data.monthlyInvoice">
          <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
          <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </b-col>
  </b-row>
  <b-collapse id="invoices_collapse" v-model="isInvoicingEnabled">
    <b-row>
      <b-col sm="12" md="2">
        <label>{{$t("views.agreements.form.vatInvoice")}}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" id="advance_payment" v-model="data.vatInvoice">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="5">
        <b-form-group>
          <label for="payment_way">{{$t('views.agreements.form.idEXSBPaymentWay')}}:</label>
          <model-select :placeholder="$t('views.agreements.form.idEXSBPaymentWay')" id="payment_way" v-model="data.idEXSBPaymentWay" :options="paymentWayOptions"></model-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="5">
        <b-form-group>
          <label for="payment_days_invoice">{{$t("views.agreements.form.paymentDaysInvoice")}}:</label>
          <input
            id="payment_days_invoice"
            v-model="data.paymentDaysInvoice"
            class="form-control"
            type="number"
            :placeholder="$t('views.agreements.form.paymentDaysInvoice')">
          <div
            v-if="isInvalid('paymentDaysInvoice')"
            class="invalid-feedback">{{ violations.paymentDaysInvoice }}</div>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group>
          <label for="invoice_comment">{{$t("views.agreements.form.invoiceComment")}}:</label>
          <textarea
            id="invoice_comment"
            v-model="data.invoiceComment"
            class="form-control"
            :placeholder="$t('views.agreements.form.invoiceComment')" />
          <div
            v-if="isInvalid('invoiceComment')"
            class="invalid-feedback">{{ violations.invoiceComment }}</div>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group>
          <b-form-checkbox
            name="invoice_append_agreement_comment"
            v-model="data.invoiceAppendAgreementComment"
            :value="1"
            :unchecked-value="0"
            class="float-left"
          >
            <span class="align-bottom">{{$t("views.agreements.form.invoiceAppendAgreementComment")}}</span>
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
  </b-collapse>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'AgreementInvoices',

  components: {
    ModelSelect
  },

  props: ['data', 'violations', 'isInvalid'],

  data () {
    return {
      isInvoicingEnabledSetter: null
    }
  },

  computed: {
    isInvoicingEnabled: {
      set (val) {
        this.isInvoicingEnabledSetter = val
      },
      get () {
        return Boolean(this.data.monthlyInvoice)
      }
    },
    ...mapGetters({
      paymentWays: 'exsbinvoice/list/paymentWayOptions'
    }),
    paymentWayOptions () {
      return this.paymentWays.map(entry => {
        return {
          value: entry['@id'],
          text: entry.name
        }
      })
    }
  },

  created () {
    if (this.paymentWayOptions.length < 1) this.fetchPaymentWayOptions()
  },

  methods: {
    ...mapActions({
      fetchPaymentWayOptions: 'exsbinvoice/list/fetchPaymentWayOptions'
    })
  }
}
</script>

<style scoped>

</style>
